module.exports = __webpack_public_path__ + "img/激活额度 (3).5f29a878.png";